import Reports from './Reports.page';

export default Reports;
